import React, { lazy } from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { History } from 'history';
import { RootState } from './store';
const NotExists = lazy(() => import('pages/404'));
const Login = lazy(() => import('pages/Login'));
const Home = lazy(() => import('containers/Home'));

interface ProtectedRouteProps {
  component: React.FC<RouteComponentProps>;
  pageLevel: number;
  path: string;
  exact?: boolean;
}

const PrivateRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  path,
  exact = false,
  pageLevel,
}: ProtectedRouteProps): JSX.Element => {
  const { secLevel } = useSelector((state: RootState) => state.secLevel);

  return (
    <Route
      exact={exact}
      path={path}
      render={(props: RouteComponentProps) => {
        if (pageLevel === secLevel) {
          return <Component {...props} />;
        }
        return <Redirect to={{ pathname: '/' }} />;
      }}
    />
  );
};

interface IRouterProps {
  history: History;
}
const Router: React.FC<IRouterProps> = ({ history }: IRouterProps) => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <PrivateRoute exact path="/home" component={Home} pageLevel={1} />
        <Route exact path="/" component={Login} />
        <Route path="*" component={NotExists} />
      </Switch>
    </ConnectedRouter>
  );
};

export default Router;
